import {Base} from "@/api/Base"

export class ServiceProviderDelete extends Base {
    path = "serviceProvider/delete"
}